import { render, staticRenderFns } from "./setMeal.vue?vue&type=template&id=6a370a36&scoped=true"
import script from "./setMeal.vue?vue&type=script&lang=js"
export * from "./setMeal.vue?vue&type=script&lang=js"
import style0 from "./setMeal.vue?vue&type=style&index=0&id=6a370a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a370a36",
  null
  
)

export default component.exports